export { Trans as Translation } from "next-i18next";
